// extracted by mini-css-extract-plugin
module.exports = {"content":"content_content__jEcP2","social":"content_social__b1tTH"};